<ng-container *transloco="let t">
  <ld-base-modal [title]="t('commonLinksTermsOfUse')" [size]="'large'" (closeModal)="onClose()">
    <div modal-content>
      <div class="prose prose-sm max-w-none font-dm text-sm text-ld-neutral leading-relaxed space-y-4">
        <p>
          <strong>Last Updated:</strong>
          January 1, 2024
        </p>

        <p>
          Welcome to loanDepot. These Terms of Use ("Terms") govern your use of our website and online services
          (collectively, the "Services"). By accessing or using our Services, you agree to be bound by these Terms.
        </p>

        <h3 class="text-base font-semibold text-ld-neutral mt-6 mb-2">1. Acceptance of Terms</h3>
        <p>
          By accessing, browsing, or using our Services, you acknowledge that you have read, understood, and agree to be
          bound by these Terms and our Privacy Policy. If you do not agree to these Terms, please do not use our
          Services.
        </p>

        <h3 class="text-base font-semibold text-ld-neutral mt-6 mb-2">2. Electronic Communications</h3>
        <p>
          When you use our Services or send emails to us, you are communicating with us electronically. You consent to
          receive communications from us electronically. We will communicate with you by email or by posting notices on
          our website. You agree that all agreements, notices, disclosures, and other communications that we provide to
          you electronically satisfy any legal requirement that such communications be in writing.
        </p>

        <h3 class="text-base font-semibold text-ld-neutral mt-6 mb-2">3. Use of Services</h3>
        <p>
          You agree to use our Services only for lawful purposes and in accordance with these Terms. You agree not to:
        </p>
        <ul class="list-disc pl-6 space-y-1">
          <li>Use the Services in any way that violates any applicable law or regulation</li>
          <li>Attempt to gain unauthorized access to any portion of the Services</li>
          <li>Use any robot, spider, or other automatic device to access the Services</li>
          <li>Introduce any viruses, malware, or other harmful material</li>
          <li>Impersonate or attempt to impersonate loanDepot or any other person or entity</li>
        </ul>

        <h3 class="text-base font-semibold text-ld-neutral mt-6 mb-2">4. Account Security</h3>
        <p>
          You are responsible for maintaining the confidentiality of your account credentials and for all activities
          that occur under your account. You agree to notify us immediately of any unauthorized use of your account or
          any other breach of security.
        </p>

        <h3 class="text-base font-semibold text-ld-neutral mt-6 mb-2">5. Intellectual Property</h3>
        <p>
          The Services and their entire contents, features, and functionality are owned by loanDepot, its licensors, or
          other providers of such material and are protected by United States and international copyright, trademark,
          patent, trade secret, and other intellectual property or proprietary rights laws.
        </p>

        <h3 class="text-base font-semibold text-ld-neutral mt-6 mb-2">6. Disclaimer of Warranties</h3>
        <p>
          THE SERVICES ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER
          EXPRESS OR IMPLIED. LOANDEPOT DISCLAIMS ALL WARRANTIES, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
        </p>

        <h3 class="text-base font-semibold text-ld-neutral mt-6 mb-2">7. Limitation of Liability</h3>
        <p>
          IN NO EVENT WILL LOANDEPOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES
          ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICES.
        </p>

        <h3 class="text-base font-semibold text-ld-neutral mt-6 mb-2">8. Changes to Terms</h3>
        <p>
          We may revise and update these Terms from time to time in our sole discretion. All changes are effective
          immediately when we post them. Your continued use of the Services following the posting of revised Terms means
          that you accept and agree to the changes.
        </p>

        <h3 class="text-base font-semibold text-ld-neutral mt-6 mb-2">9. Contact Information</h3>
        <p>
          If you have any questions about these Terms, please contact us at
          <a [href]="supportEmailMailto" class="text-ld-link hover:underline">{{ supportEmail }}</a>
          or call us at
          <a [href]="supportPhoneTel" class="text-ld-link hover:underline">{{ supportPhone }}</a>
          .
        </p>

        <p class="text-xs text-gray-500 mt-6">
          loanDepot, LLC NMLS ID 174457. Licensed by the Department of Financial Protection and Innovation under the
          California Residential Mortgage Lending Act.
        </p>
      </div>
    </div>
    <div modal-footer>
      <button id="terms-of-use-done-btn" type="button" class="btn-primary-ld-purple" (click)="onDone()">
        {{ t('commonButtonsDone') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
